import './ModalExpired.scss';

import { useDispatch } from "react-redux";

import { logoutUser } from "../../slices/authSlice";

import { Box } from "@mui/material";

import { LargeTitle } from "../../common-components/Titles/Titles";
import { MiddleTitle } from "../../common-components/Titles/Titles";
import { ButtonGateway } from "../../common-components/Buttons/Buttons";

const ModalExpired = ({ isOpen, onClose }) => {
    const dispatch = useDispatch();
    if (!isOpen) return null;

    const handleClick = () => {
        dispatch(logoutUser());
        onClose();
    }

    return (
        <Box className={"modal_expired"}>
            <Box className={"modal_expired_container"}>
                <Box className={"modal_expired_container_title"}>
                    <LargeTitle property={"Сессия истекла"}/>
                </Box>
                <Box className={"modal_expired_container_message"}>
                    <MiddleTitle property={"Сессия истекла, перезайдите в приложение пройдя повторную авторизацию"}/>
                </Box>
                <Box className={"modal_expired_container_button"}>
                    <ButtonGateway onClick={handleClick}/>
                </Box>
            </Box>
        </Box>
    )
}

export default ModalExpired;